import BlogsSection from "./blogs";
import CTASection from "./cta";
import DevOpsSection from "./dev-ops";
import HeroSectionControl from "./hero";
import IntegrationSection from "./integrations";
import ScalingSection from "./scaling";
import JiraSoftwareNav from "./software-jira-navbar";
import TabsSection from "./tabs";
import WorkflowSection from "./workflow";

export {
    BlogsSection,
    CTASection,
    DevOpsSection,
    HeroSectionControl,
    IntegrationSection,
    ScalingSection,
    JiraSoftwareNav,
    TabsSection,
    WorkflowSection
};
